import * as THREE from 'three';

export const PALETTE = {
  floorSalon: 0xc4a574,
  floorPatio: 0x8b9a6b,
  floorKitchen: 0xd8d0c4,
  floorTile: 0xe8e2d6,
  wall: 0xf5f0e6,
  wood: 0x6b4423,
  woodLight: 0x9c6b3c,
  metal: 0x6a7078,
  accent: 0xc45c3e,
  brand: 0x8b1e1e,
  glass: 0xa8d4e6,
  emissiveWarm: 0xffa040,
};

export function mat(color: number, opts?: Partial<THREE.MeshStandardMaterialParameters>) {
  return new THREE.MeshStandardMaterial({ color, roughness: 0.72, metalness: 0.05, ...opts });
}
